import { Typography } from '@mui/material';

type HighlightTextProps = {
    text: string;
    term: string;
};

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const HighlightText = ({ text, term }: HighlightTextProps) => {
    const normalizedTerm = term.trim();

    if (!normalizedTerm) {
        return <>{text}</>;
    }

    const termRegex = new RegExp(`(${escapeRegExp(normalizedTerm)})`, 'gi');
    const chunks = text.split(termRegex);

    return (
        <>
            {chunks.map((chunk, index) => {
                if (chunk.toLowerCase() !== normalizedTerm.toLowerCase()) {
                    return <span key={`chunk-${index}`}>{chunk}</span>;
                }

                return (
                    <Typography key={`chunk-${index}`} component="span" color="primary.main">
                        {chunk}
                    </Typography>
                );
            })}
        </>
    );
};